import React from 'react';
import Box from '@mui/material/Box';
import skywarnEye from '../images/loading.gif'

const Loading = () => {
   return (
        <Box sx={{ mt: '23vh', mb: 5, textAlign: 'center' }}>
            <Box component="img" src={skywarnEye} alt="Loading" sx={{ maxWidth: '100%' }} />
        </Box>
   )
};

export default Loading;
